export const fmt = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

import { getBackendUrl } from "./backendUrl";

const BACKEND_URL = getBackendUrl();

/** Returns the image URL, preferring locally-cached paths for performance. */
export const proxyImg = (url) => {
  if (!url) return "/assets/biofarmax-logo.png";
  // Pass-through: relative paths served by our own backend/frontend (no proxy needed)
  if (url.startsWith("/products/") || url.startsWith("/assets/") || url.startsWith("/api/images/") || url.startsWith("/api/img/")) return url;
  if (url.startsWith("data:")) return url;
  if (url.includes("static.prod-images.emergentagent.com") || url.includes("images.unsplash.com") || url.includes("customer-assets.emergentagent.com")) return url;
  return `${BACKEND_URL}/api/img-proxy?url=${encodeURIComponent(url)}`;
};

export const slugIcon = {
  saude: "HeartPulse",
  fitness: "Dumbbell",
  "bem-estar": "Sparkles",
  pele: "Sun",
};
